import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { ActuatorHealth } from 'src/rdsap-api/model/actuatorHealth';

// Define the custom entity collection service
// This service is used to provide access to the RdSAPLookUpCodes data service
@Injectable({ providedIn: 'root' })
export class RdSAPHealthService extends EntityCollectionServiceBase<ActuatorHealth> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('RdSAPHealth', serviceElementsFactory);
  }
}
